import {gql} from '@apollo/client';

export const FETCH_TRANSACTIONS_QUERY = gql`
  query getTransactions{
    getTransactions {
      id
      category
      value
      createdAt
      user
      desc
    }
  }
`;